
import React, { useState, useEffect } from 'react'
import { Cascader, Select, Form, Button, Row, DatePicker, message, Upload, Input, Radio } from "antd"
import { DownloadOutlined, PlusOutlined, UploadOutlined, DeleteOutlined } from '@ant-design/icons';
const { TextArea } = Input
const { Option } = Select
import RoleApi from '@api/role'
import AddModal from '@components/Modal'
import { identifierData,getTreeData } from '@utils/common'
import moment from 'moment';
import stationApi from '@api/station'
// const { UPLOADER } = window.globalConfig;
import InspectionApi from '@api/inspectionnew'

const layout = {
  labelCol: { span: 4 },
  wrapperCol: { span: 17 },
};
export default ({ title, visible, formData = null, cancel,stationData }) => {
  const [form] = Form.useForm();
  const [formValue, setFormValue] = useState()
  const [loading, setLoading] = useState()
  // 处理人列表
  const [personItems, setPersonItems] = useState([])
  const [sourceIdArr,setSourceIdArr] = useState([])
  const [imageUrls, setImageUrls] = useState([])
  const [deviceLs, setDeviceLs] = useState([])
    // 缺陷等级列表
    const [defectslevelLs, setDefectslevelLs] = useState([])
  // 厂站集合
  const [patrolItemParams, setPatrolItemParams] = useState({
    stationId: '',
    type: '',
    materielId: '',
    processunitClassifyId: '',
    processunitId: '',
    deviceClassifyId: '',
  })
  useEffect(() => {
    // 关联id
    // getSource()

    // 缺陷等级列表
    InspectionApi.defectLevel({ pageNum: 1, pageSize: 100000 }).then(res => {
      setLoading(false)
      if (res.status == 0 && res.data) {
        setDefectslevelLs(res.data.data)
      }
    })

    // 获取人员列表
    if (formData) {
      RoleApi.queryRoleUserByIdentifier({ stationIds: formData.stationId, identifier: identifierData[0] }).then(res => {
        if (res.status == 0 && res.data) {
          setPersonItems(res.data || [])
        }
      })
    }
    return () => { }
  }, [])
  const getSource = async () => {
    const res = await InspectionApi.taskQuery({pageNum: 1, pageSize: 100000})
    setSourceIdArr([...res.data.data])
  }
  useEffect(() => {
    if (patrolItemParams.stationId && patrolItemParams.type === 0) {
      
    }
    return () => { }
  }, [patrolItemParams])

  // 上传前进行图片限制处理
  const beforeUpload = (file) => {
    const isJpgOrPng = file.type === 'image/jpg' || file.type === 'image/jpeg' || file.type === 'image/png';
    if (!isJpgOrPng) {
      message.error('图片格式不正确!');
    }
    const isLt2M = file.size / 1024 / 1024 < 7;
    if (!isLt2M) {
      message.error('图片最大7M!');
    }
    return isJpgOrPng && isLt2M;
  }

  const uploadResultImg = (info) => {
    const {file} = info
    if (file.status === 'done') {
      const { response: res } = file
      if ( res.status !== '0' ) return
      setImageUrls([...imageUrls, res.data.url])
    }
  }

  const removeResultImg = (info) => {
    const { response: res } = info
    const url = res.data.url
    const params = imageUrls
    const index = params.findIndex(item => item === url)
    params.splice(index,1)
    setImageUrls([...params])
  }
  
  const setNodeChildren = (data, resData, id, key) => {
    return data.map(v => {
      if (v.children) {
        v.children = setNodeChildren(v.children, resData, id, key)
      }
      console.log(id, v.value)
      if (id === v.value.substr(1)) {
        v.children = resData
      }
      return v
    })
  }

  const changeSourceTy = async (e) => {
    setSourceIdArr([])
    if (e) {
      // 0-巡检任务，1-保养任务
      const res = await InspectionApi.upkeepQuery({pageNum: 1, pageSize: 100000})
      setSourceIdArr([...res.data.data])
    } else {
      const res = await InspectionApi.taskQuery({pageNum: 1, pageSize: 100000})
      setSourceIdArr([...res.data.data])
    }
  }

  const changStation = (e) => {
    stationApi.getDeviceByStationId({ stationId: e }).then(res => {
      if (res.status !== '0') return
      setDeviceLs(getTreeData(res.data))
    })
  }

  const getChild = (arr) => {
    const role = form.getFieldValue('handleRole')
    return arr.map(item => {
      if(item.children && item.children.length > 0){
        item.children = getChild(item.children);
        if(role !='area_manager'){
          item.disabled = item.deviceId?false:true;
        }
        return item;
      } else {
        delete item.children;
        if(role !='area_manager'){
          item.disabled = item.deviceId?false:true;
        }
        return item;
      }

    })
  }
  // 提交
  const submit = () => {
    form.validateFields().then(values => {
      if(!values){
        return;
      }
      setLoading(true)
      const params = JSON.parse(JSON.stringify(values))
      params.discoveryTime = moment(params.discoveryTime).format('YYYY-MM-DD HH:mm:ss')
      params.planCloseTime = moment(params.planCloseTime).format('YYYY-MM-DD HH:mm:ss')
      params.deviceRelevancyId = params.deviceRelevancyId[params.deviceRelevancyId.length-1]
      params.insertType = 1
      // params.sourceType = 0
      params.imageUrls = imageUrls
      if(formData && formData.id){

      } else {
        InspectionApi.defectAdd(params).then(res => {
          if (res.status == 0) {
            message.success('添加成功')
            handelCancel(true)
          }
          setLoading(false)
        }).catch((err) => {
          setLoading(false)
        })
      }
      
      
    })
  }
  // 取消
  const handelCancel = (bool = false) => {
    form.resetFields();
    cancel(bool);
  }
  return (
    <AddModal title={title} footer={[
      <Row key={'btn'} span={24}>
        <Button key={1} onClick={handelCancel} className='abuttons'>
          <i className='iconfont iconfanhui'>
          </i>&nbsp;&nbsp;取消
        </Button>
        <Button key={2} loading={loading} onClick={submit} className='abuttons' type="primary">
          <i className='iconfont iconbaocun'>
          </i>&nbsp;&nbsp;保存
        </Button>
      </Row>]
    } visible={visible} width={800} okText={'确定'} onCancel={handelCancel} onSubmit={() => submit()}>
      <div className='userModal'>
        <Form
          {...layout}
          // name="basic"
          layout="horizontal"
          form={form}
          style={{ marginTop: '20px' }}
          initialValues={formValue}
        >
            <Form.Item
              label='巡检厂站'
              name="stationId"
              rules={[{ required: true, message: '请选择巡检厂站' }]}
            >
              <Select
                allowClear
                onChange={(val) => changStation(val)}
                placeholder="请选择巡检厂站">
                {
                  stationData && stationData.map((item, idx) => {
                    return (
                      <Option value={item.value} key={'stationId-' + idx}>{item.title || item.name}</Option>
                    )
                  })
                }
              </Select>
            </Form.Item>
            <Form.Item label="巡检设备" name="deviceRelevancyId" rules={[{ required: true, message: '请选择巡检设备' }]}>
              <Cascader options={deviceLs} placeholder="请选择设备" />
            </Form.Item>
            <Form.Item
              label='是否安全隐患'
              name='safetyPerilFlag'
              rules={[{ required: true, message: '请选择是否安全隐患!' }]}
            >
              <Radio.Group>
                <Radio value={0}>否</Radio>
                <Radio value={1}>是</Radio>
              </Radio.Group>
            </Form.Item>
            <Form.Item
              label='缺陷等级'
              name='defectLevelId'
              rules={[{ required: true, message: '请选择缺陷等级' }]}
            >
              <Select placeholder={'请选择缺陷等级'}>
                {
                  defectslevelLs && defectslevelLs.map(item => {
                    return <Option value={item.id} key={item.id}>{item.defectLevelName}</Option>
                  })
                }
              </Select>
            </Form.Item>
            {/* <Form.Item label="来源类型" name="sourceType" rules={[{ required: true, message: '请选择来源类型' }]}>
              <Select placeholder="来源类型" onChange={ (e) => changeSourceTy(e) }>
                <Option value={0}>巡检任务</Option>
                <Option value={1}>保养任务</Option>
              </Select>
            </Form.Item> */}
            {/* <Form.Item label="关联id" name="sourceId" rules={[{ required: true, message: '请选择关联id' }]}>
              <Select placeholder="关联id">
                {
                  sourceIdArr.length > 0 && sourceIdArr.map(item => {
                    return <Option value={item.id} key={item.id}>{item.taskName}</Option>
                  })
                }
              </Select>
            </Form.Item> */}
            <Form.Item
                label='发现时间'
                name='discoveryTime'
                rules={[{ required: true, message: '请选择发现时间!' }]}
              >
                <DatePicker
                  format="YYYY-MM-DD HH:mm:ss"
                  showTime={{ defaultValue: moment('00:00:00', 'HH:mm:ss') }}
                />
              </Form.Item>
            <Form.Item 
                label='计划关闭时间'
                name='planCloseTime'
                rules={[{ required: true, message: '请选择计划关闭时间!' }]}
              >
                <DatePicker
                  format="YYYY-MM-DD HH:mm:ss"
                  showTime={{ defaultValue: moment('00:00:00', 'HH:mm:ss') }}
                />
              </Form.Item>
              <Form.Item
                label='缺陷描述'
                name="deffectRemark"
                rules={[{ required: true, message: '请输入缺陷描述' }]}
              >
                <TextArea rows={4} placeholder="请输入缺陷描述" />
              </Form.Item>
              <Form.Item
                label='上传图片'
              >
                <Upload
                  name='file'
                  action={window.globalConfig.UPLOADER}
                  headers={{authorization: sessionStorage.getItem('token')}}
                  beforeUpload={(e) => beforeUpload(e)}
                  onChange={ (e) => uploadResultImg(e) }
                  onRemove={ e => removeResultImg(e) }
                >
                  <Button icon={<UploadOutlined />}>上传图片</Button>
                </Upload>
              </Form.Item>
        </Form>
      </div>
    </AddModal>
  )

}
